import { Component } from 'src/utils';
import template from './forgot-password.html';
import resetPwdImg from './../../../images/reset-pass-2.png';
import confirmImg from './../../../images/tick-sent.png';


@Component({
  controllerAs: 'forgotPwd',
  template
})

export default class ForgotPasswordContainer {
  static $inject = [
    'authService'
  ];

  constructor(authService) {
    this.authService = authService;
    this.resetPwdImg = resetPwdImg;
    this.confirmImg = confirmImg;
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
    form.error = {};
    this.authService.forgotPassword({
      email: this.email
    })
      .then(() => this.requestSent = true)
      .catch(err => form.error = err.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/forgot-password.js